import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './core/component/loader/loader.component';
import { AuthStorageSyncService } from './core/service/auth-storage-sync.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor() {
    // App-wide, not only in the main layout: a tab on the sign-in screen must follow too.
    inject(AuthStorageSyncService).start();
  }
}
